<template>
  <div class="Header" ref='appheader'>
    <div class="header_content clearfix">
      <div class="header_content_left">
        <img class="logo" :src="require('@/assets/logo_new.png')" alt="">
        <div class="nav">
          <router-link  to="/index" tag="a" class="">
                 <span >首页</span>
          </router-link>
          <span @click="goUrl">数据分析</span>
          <span @click="godeyu" v-if="'show.yuzanyun.com'.indexOf(url) != -1">德育一体机</span>
          <!-- <span @click="goqiant" v-if="'show.yuzanyun.com'.indexOf(url) != -1">德育前台</span> -->
        </div>
        <div class="search_box">
          <el-input class="input325" :class="{focus:focus}" placeholder="请输入名称进行搜索" v-model="searchData.keyword" @keyup.enter.native="onSubmit()" @focus="focus=true" @blur="focus=false">
            <i slot="suffix" >
              <svg class="icon searchIcon" aria-hidden="true" @click="onSubmit()">
                <use xlink:href="#iconsousuo"></use>
              </svg>
            </i>
          </el-input>
        </div>
      </div>
      <div class="header_content_left1">
        
        <div class="user_btn">
          <i class="icon el-icon-s-tools" v-if="auth==1" @click='goSetBanner'></i>
          <span class="iconfont iconlingdang" :class="{active:version.active}" @click="showVersion"> <b></b></span>
          <el-avatar size="small" :src="userinfo.userInfo.headImage">
            <img v-if="userinfo.userInfo.sex=='女'" src="../../../../assets/nv_icon.png" alt="">
            <img v-else src="../../../../assets/nan_icon.png" alt="">
          </el-avatar>
          <el-dropdown>
              <span class="el-dropdown-link">
                {{userinfo.userInfo.realname}}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item >
                  <a href="javascript:;" @click="goApplication">进入后台</a> 
                  
                  </el-dropdown-item>
                <el-dropdown-item  >
                  <!-- <a href="javascript:;" @click="goApplication">个人信息</a>  -->
                  <router-link  to="/setting"   tag="a" class="navigation">个人信息</router-link>
                </el-dropdown-item>
                <el-dropdown-item>
                  <a href="/user/logout.do" target="_top">退出登录</a>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
        </div>
         <div class="ver_box" v-if="ver.versionName.length">
          <img :src="ver.versionImg" alt=""><span>{{ver.versionName}}</span>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import { presentVersion,userinfo,myAuth,getModifySchoolLoginPage,schoolInfo,findCurrentVersion } from '@/api/common_api'
import bus from '@/utils/bus'
import {mapActions, mapState} from 'vuex'
export default {
  name: 'Header',
  data() {
    return {
       focus: false,
       searchData: {
        keyword: '',
      },
      version: '',
      userinfo:{
        userInfo:{
          headImage:'',
          realname:''
        }
      },
      auth:0,
      logo: {
        logo: '@/assets/logo_new.png'
      },
      isShow:false,
      schoolId:'',
      url: window.location.host,
      ver:{versionName:'',versionImg:''}
    }
  },
  computed: {
    ...mapState([
        'userInfo'
      ]),
  },
  watch: {
    
  },
  computed: {
    
  },
  mounted () {
    let _this=this
    this.$nextTick(() => {
      _this.$refs.appheader.style.width=document.body.clientWidth+'px'
      window.onresize = function(){
        if(document.body.clientWidth>1205){
          _this.$refs.appheader.style.width=document.body.clientWidth+'px'
        }
        
      }
      window.addEventListener('scroll', _this.getScrollLeft);
    });
  
  },
  created() {
    let _this = this
    this.getVer()
    let edition=localStorage.getItem('edition4')
      presentVersion().then(res => {
        if (res.s == 1) {
          if(res.d){ 
            if(res.d.value!=edition){
              res.d.active=true
            }else{
               res.d.active=false
            }
            _this.version = res.d
            
          }else{
            _this.version = {
              value:'0',
              descr:'暂无版本信息'
            }
          }
        }
      })
      userinfo().then(res => {
        if (res.s == 1) {
          _this.userinfo=res.d
          _this.getLogo(_this.userinfo.userInfo.schoolId)
         
          _this.increment({ userInfo:  _this.userinfo });
        }else if(res.s == 2){
          let domain = window.location.host;
          let url= window.location.protocol+'//' + domain
          window.open(url)
        }
      })
      myAuth().then(res=>{
        if (res.s == 1) {
         _this.auth=res.d
        }
      })
  
      schoolInfo().then(res => {
        if (res.s == 1) {
          this.schoolId = res.d.schoolId
        }
      })
  
  
  },
  methods: {
    ...mapActions([
      'increment'
    ]),
    getVer(){
      findCurrentVersion().then(res=>{
        if(res.s==1){
          this.ver = res.d
        }
      })
    },
    getLogo(id){
      let _this=this
      let obj={
        id:id
      }
      getModifySchoolLoginPage(obj).then(res=>{
        if (res.s == 1) {
         _this.logo=res.d
         
        }
      })
    },
    goUrl(){
     
       let domain = window.location.host,url='';
       if(this.schoolId=='1803572196297728'){
         url= window.location.protocol+'//' + domain +'/index/dataBrain.do?url=ohwgy'
       }else{
         url= window.location.protocol+'//' + domain +'/index/dataBrain.do?url=index'
       }
        window.open(url)
    },
    goqiant(){
      window.open('http://yun.ohzyzz.cn:8088/homepage/toIndex.do')
    },
    godeyu(){
      window.open('http://testdemo.yuzanyun.com/dist/#/')
    },
    getScrollLeft() {
      
        var scrollLeft=0,
            bodyScrollLeft = 0,
            documentScrollLeft = 0;    
        if (document.body) {
           
            bodyScrollLeft =document.body.scrollLeft;
        }
        if (document.documentElement) {
           
            documentScrollLeft =document.documentElement.scrollLeft;
        }
        scrollLeft=(bodyScrollLeft - documentScrollLeft > 0) ? bodyScrollLeft : documentScrollLeft;
        
        this.$refs.appheader.style.left = -scrollLeft+'px'
        this.$refs.appheader.style.width=document.body.clientWidth
        
       
    },
    goSetBanner(){
      this.$router.push({
        path:'/setCenter'
      })
    },
    showVersion() {
     let _this = this
      if(_this.version!=''){
        localStorage.setItem('edition4',_this.version.value)

       _this.version.active=false
       
       
      }else{
        _this.version={
          value:'',
          descr:'暂无版本信息'
        }
      }
      this.$alert(_this.version.descr, '版本信息：'+_this.version.value, {
          confirmButtonText: '确定',
          dangerouslyUseHTMLString: true,
          callback: action => {
          }
        });
    },
   onSubmit() {
    let _this=this
    let obj=JSON.parse(JSON.stringify(this.searchData))
    bus.$emit('search',obj)
  },
   goApplication(){
      let domain = window.location.host;
      let url= window.location.protocol+'//' + domain +'/user/index.do'
      window.open(url)
   }
  }
}
</script>

<style lang="less" scoped>
.Header{
  height:48Px;
  font-size:14Px;
  box-sizing: border-box;
  padding:7Px 0;
  min-width:1200Px;
  background:#fff;
  position:fixed;
  top:0;
  left:0;
  z-index:999;
  box-shadow: 0px 2Px 2Px 0px rgba(232,232,232, 0.5);
  .header_content{
    width:1205Px;
    margin:0 auto;
    height:100%;
    min-width:960Px;
    .header_content_left{
      height:100%;
      box-sizing: border-box;
      padding:2Px 0;
      max-width:830Px;
      float:left;
      .logo{
         height:100%;
         margin-left:20Px;
         margin-right:40px;
      }
      .nav{
        line-height:30Px;
        display:inline-block;
        height:30Px;
        vertical-align: top;
        span{
          color:#444440;
          margin-left:20Px;
          transition: 0.5s;
          cursor: pointer;
          &.active,&:hover{
            color:#191919;
            font-weight: 600;
          }
          
        }
      }
      .search_box{
        display:inline-block;
        vertical-align: top;
        // float:right;
        margin-left: 48Px;
        .searchIcon{
          width:20Px;
          height:20Px;
          cursor: pointer;
        }
      }
      .input325{
        width:200Px;
        transition: 0.5s; 
      }
      .input325.focus{
        width:220Px;
        min-width:225Px;
      }
    }
    .header_content_left1{
      float:right;
      
      // width:370Px;
      //  max-width:370Px;
      .user_btn{
        float:right;
        .iconfont,.icon{
          margin-right:30Px;
          vertical-align: top;
          line-height:30Px;
          color:#999999;
          cursor:pointer;
          position:relative;
          display: inline-block;
          b{
            display: none;
            width:4Px;height: 4Px;
            border-radius: 50%;
            background:red;
            position:absolute;
            right:0;
            top:0;
          }
          &.active{
            position: relative;
            b{
              position: absolute;
              display:inline-block;
              top: 5Px;
            }
          }
        }
        .iconfont{
          font-size:15Px;
          &:hover,&:active{
            color:#8191a5;
          }
        }
        .icon{
          margin-right:20Px;
        }
        .el-dropdown{
           vertical-align: top;
          line-height:30Px;
          margin-left:10Px;
          .el-icon--right{
            font-size:12Px;
          }
          
          &:hover{
            color:#66b1ff;
          }
        }
      }
    }
  }
  .ver_box{
    float: right;
    display: flex;
    align-items: center;
    margin-right: 10Px;
    height: 31Px;
    img{
      max-width: 100Px;
      max-height: 34Px;
      margin-right: 10Px;
    }
  }
}
</style>
